export default __webpack_public_path__ + "static/media/TubeStandXLShort.abd1d0b9.svg";